import moment from 'moment-timezone'

const apiUrlProd = window.config ? window.config.apiUrlProd : ''
const signalrUrl = window.config ? window.config.signalrUrl : ''

export default {
  namespaced: true,
  elapsedTime: function (time, status) {
    // Resource: http://jsfiddle.net/cckSj/5/
    if (['closed', 'voided ro'].indexOf(status.toLowerCase()) > -1) {
      return null
    }
    // Time when the change was made on database (database time)
    var startTime = new Date(time)
    // Current time (user time)
    // IMPORTANT: I'm adding a minute since seems like PROD DB has 12 seconds behind of difference making it to display a negative -1 minute instead of 0 minutes.
    var endTime = new Date(moment().add(1, 'minutes').tz('US/Central').format('YYYY-MM-DD HH:mm:ss'))
    // time difference in ms
    var timeDiff = endTime - startTime
    // strip the miliseconds
    timeDiff /= 1000
    // get seconds
    // var seconds = Math.round(timeDiff % 60)
    // remove seconds from the date
    timeDiff = Math.floor(timeDiff / 60)
    // get minutes
    var minutes = Math.round(timeDiff % 60)
    // remove minutes from the date
    timeDiff = Math.floor(timeDiff / 60)
    // get hours
    var hours = Math.round(timeDiff % 24)
    // remove hours from the date
    timeDiff = Math.floor(timeDiff / 24)
    // the rest of timeDiff is number of days
    var days = timeDiff
    var timeElapsed = ''
    // Show day(s)
    if (days > 0) {
      timeElapsed = days === 1 ? days + ' day, ' : days + ' days, '
    }
    // Show Hours
    if (hours > 0) {
      timeElapsed += hours > 0 ? hours === 1 ? hours + ' hr ' : hours + ' hrs ' : ' '
    }
    // Show Minutes
    // Since we aren't displaying seconds we have the following problem:
    // Sometimes, seconds equals to ~59 and minutes equals to 0.
    // So, in that case, "x minutes" won't be display at the DOM because it's 0. To fix this, we'll set minutes to 1 if it's actually 0.
    // With this, even if minutes equals 0 (really ~59 seconds), it will be displayed as "1 minute"
    minutes = minutes === 0 ? 1 : minutes
    if (minutes > 0) {
      timeElapsed += minutes === 1 ? minutes + ' min ' : minutes + ' mins '
    }
    if (days > 1000) {
      timeElapsed = status
    }
    // Update object
    return timeElapsed
  },
  isNumeric: function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n)
  },
  getApp: function () {
    return localStorage.getItem('appId')
  },
  setApp: function (id) {
    localStorage.setItem('appId', id)
  },
  apiUrl: function () {
    let _url = apiUrlProd
    return _url
  },
  signalrUrl: function () {
    let _url = signalrUrl
    return _url
  },
  scrollToBottom(target) {
    target.scrollTop = target.scrollHeight - target.clientHeight
  }
}



// WEBPACK FOOTER //
// ./src/plugins/globals.js